export const USER_ADMIN        = 'admin';
export const USER_CLIENT       = 'client';
export const USER_AGENCY       = 'agency';
export const USER_FREELANCE    = 'freelance';